import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import { Button } from "@mui/material";
import { Chip, Tooltip } from "@mui/material";
import axios from "axios";

import PostCard from "./PostCard";
// import { posts } from "../../data/home";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

function RightHome() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get("api/invitation/all")
      .then((res) => {
        setPosts(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const profile = false;

  return (
    <div className="rightHome">
      {/* <h1 className="header">PROJECTS</h1> */}

      {/* <Stack class="stack"> */}
      {posts.map((post) => (
        <PostCard key={post._id} post={post} profile={profile} />
      ))}
      {/* </Stack> */}
    </div>
  );
}

export default RightHome;
